import AddPhoto from "./AddPhoto";

export default AddPhoto;